export const INVITATION_ROLES = Object.freeze(['ADMIN', 'MEMBER'])

export function organizationLabel(organization, translate = () => null) {
	if (!organization) return ''
	if (organization.kind === 'PERSONAL') {
		return translate(organization.systemLabelKey) || 'Личное'
	}
	return organization.name || ''
}

export function invitationRoleOptions(organization, membershipRole) {
	if (organization?.kind !== 'TEAM') return []
	if (membershipRole === 'OWNER') return [...INVITATION_ROLES]
	if (membershipRole === 'ADMIN') return ['MEMBER']
	return []
}

export function canCreateTeam(isAuthenticated) {
	return Boolean(isAuthenticated)
}

export function isOrganizationSelected(organization, selectedOrganizationId) {
	return Boolean(organization && organization.id === selectedOrganizationId)
}

export function normalizeTeamName(value) {
	return String(value || '').trim()
}

export function normalizeInvitationEmail(value) {
	return String(value || '').trim().toLowerCase()
}

export function safeOrganizationActionError(error) {
	const code = error?.response?.data?.error?.code || error?.code
	const messages = {
		TEAM_NAME_REQUIRED: 'Введите название агентства.',
		TEAM_NAME_INVALID: 'Название агентства должно содержать от 1 до 200 символов.',
		INVITATION_EMAIL_INVALID: 'Введите корректный email.',
		INVITATION_ROLE_INVALID: 'Выберите допустимую роль.',
		INVITATION_ALREADY_PENDING: 'Для этого email уже есть ожидающее приглашение.',
		MEMBERSHIP_ALREADY_ACTIVE: 'Пользователь уже состоит в этом агентстве.',
		INVITATION_NOT_FOUND: 'Приглашение не найдено или больше недоступно.',
		INVITATION_EXPIRED: 'Срок действия приглашения истёк.',
		INVITATION_NOT_PENDING: 'Приглашение уже было использовано или отозвано.',
		INVITATION_IDENTITY_MISMATCH: 'Приглашение предназначено для другого аккаунта.',
		ORGANIZATION_ACTION_FORBIDDEN: 'Недостаточно прав для этого действия.',
		ORGANIZATION_CONTEXT_FORBIDDEN: 'Доступ к агентству изменился. Контекст обновлён.',
		QUOTA_EXCEEDED: 'Достигнут текущий лимит участников агентства.',
	}
	return messages[code] || 'Не удалось выполнить действие. Повторите попытку.'
}
